import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  size?: 'md' | 'lg' | 'xl';
}
export function Button({
  children,
  fullWidth = false,
  size = 'lg',
  className = '',
  ...props
}: ButtonProps) {
  const sizeClasses = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  return <motion.button whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative overflow-hidden rounded-full bg-violet-600 text-white font-bold tracking-wide
        shadow-[0_8px_20px_rgb(124,58,237,0.3)] hover:shadow-[0_12px_25px_rgb(124,58,237,0.4)]
        transition-all duration-300 ease-out
        ${sizeClasses[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-277">
      <div className="absolute inset-0 bg-gradient-to-r from-violet-600 to-purple-500 opacity-0 hover:opacity-100 transition-opacity duration-300" data-id="element-278" />
      <span className="relative z-10" data-id="element-279">{children}</span>
    </motion.button>;
}
export const CHECKOUT_URL = 'https://checkout.aula-mater.online/cart/66759304020013:1';
interface CTAProps {
  className?: string;
  href?: string;
  scrollTo?: string;
  label?: string;
}
export function CTA({
  className = '',
  href,
  scrollTo,
  label = 'QUIERO ACCEDER AHORA'
}: CTAProps) {
  const handleClick = () => {
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
      return;
    }
    if (href) {
      window.location.href = href;
    }
  };
  return <div className={`flex flex-col items-center gap-3 ${className}`} data-id="element-280">
      <Button size="xl" className="w-full sm:w-auto min-w-[280px]" onClick={handleClick} data-id="element-281">
        {label}
      </Button>
      <div className="flex items-center gap-2 text-xs font-medium text-slate-500" data-id="element-282">
        <span data-id="element-283">Garantía 7 días</span>
        <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-284" />
        <span data-id="element-285">Pago seguro</span>
        <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-286" />
        <span data-id="element-287">Mercado Pago</span>
      </div>
    </div>;
}